import { render, staticRenderFns } from "./contentCompanySetting.vue?vue&type=template&id=493c1d3f&"
import script from "./contentCompanySetting.vue?vue&type=script&lang=js&"
export * from "./contentCompanySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports